import { render, staticRenderFns } from "./wechatset.vue?vue&type=template&id=2d93969e&scoped=true"
import script from "./wechatset.vue?vue&type=script&lang=js"
export * from "./wechatset.vue?vue&type=script&lang=js"
import style0 from "./wechatset.vue?vue&type=style&index=0&id=2d93969e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d93969e",
  null
  
)

export default component.exports